


























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class TopoChart extends Vue {
  @Prop() private title!: string;
  @Prop() private data!: any;
  @Prop() private unit!: string;
  @Prop() private intervalTime!: number[];
  @Prop() private precent!: boolean;
  get content() {
    if (!this.data.length) {return 0; }
    const noZero = this.data.filter((i: any) => i);
    const sum = noZero.length ? noZero
    .reduce((preValue: number, curValue: number, index: number, array: number[]) => preValue + curValue)
    / noZero.length : 0;
    return this.precent ? sum / 100 : sum;
  }
  get responseConfig() {
    return {
      color: [
        '#3f96e3ee',
        '#6be6c1',
      ],
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#333844',
        textStyle: {
          fontSize: 13,
        },
      },
      grid: {
        top: 4,
        left: 0,
        right: 0,
        bottom: 7,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        axisTick: {
          lineStyle: { color: '#c1c5ca41' },
          alignWithLabel: true,
        },
        splitLine: { show: false },
        axisLine: { lineStyle: { color: 'rgba(0,0,0,0)' } },
        axisLabel: { color: '#9da5b2', fontSize: '11' },
      },
      yAxis: {
        type: 'value',
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: '#c1c5ca41', type: 'dashed' } },
        axisLabel: { color: '#9da5b2', fontSize: '11' },
      },
      series: [
        {
          data: this.data.map((i: any, index: number) => [
            this.intervalTime[index],
            i,
          ]),
          type: this.precent ? 'bar' : 'line',
          symbol: 'none',
          barMaxWidth: 5,
          lineStyle: {
            width: 1,
          },
        },
      ],
    };
  }
}
